import { __awaiter, __generator, __read } from "tslib";
import { fetchOfficeComponentContext } from '@office-start/component-context-service';
import { queryCache } from '@office-start/data-fetching';
import { fetchIdentity } from '@office-start/identity-service';
import { mark as markPerformance } from '@office-start/performance-service';
import { executeFeatureGatesDataFlow } from './executeFeatureGatesDataFlow';
var featureGates = undefined;
export function fetchFeatureGates() {
    var _this = this;
    if (featureGates) {
        return Promise.resolve({
            result: featureGates,
            fromPersistence: false,
        });
    }
    var query = ['FeatureGates'];
    return queryCache.fetchQuery(query, function () { return __awaiter(_this, void 0, void 0, function () {
        var _a, componentContext, identity;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, Promise.all([
                        fetchOfficeComponentContext(),
                        fetchIdentity(),
                    ])];
                case 1:
                    _a = __read.apply(void 0, [_b.sent(), 2]), componentContext = _a[0], identity = _a[1];
                    markPerformance("FetchFeatureGatesAsync" /* KnownPerformanceMarks.FetchFeatureGatesAsync */, "React_Render_Ohome_Start" /* KnownPerformanceMarks.ReactRenderOhomeStart */);
                    return [2 /*return*/, executeFeatureGatesDataFlow(identity, componentContext)];
            }
        });
    }); }, {
        staleTime: Infinity,
        cacheTime: Infinity,
    });
}
export function setFeatureGates(fg) {
    featureGates = fg;
}
export function getFeatureGates() {
    return {
        result: featureGates,
        fromPersistence: false,
    };
}
//# sourceMappingURL=fetchFeatureGates.js.map